import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['template', 'dialog', 'inner']
  static classes = ['active']

  #closing = false

  dialogTargetConnected(element) {
    window.addEventListener('keydown', this.#closeOnEsc)
    element.addEventListener('click', this.#closeOnBackdrop)
  }

  dialogTargetDisconnected(element) {
    window.removeEventListener('keydown', this.#closeOnEsc)
    element.removeEventListener('click', this.#closeOnBackdrop)
  }

  showModal() {
    if (!this.hasDialogTarget) {
      this.element.appendChild(this.#template)
    }

    this.dialogTarget.classList.add(this.activeClass)
    this.dialogTarget.showModal()
  }

  async close() {
    if (!this.hasDialogTarget || this.#closing) return

    this.#closing = true

    this.dialogTarget.classList.remove(this.activeClass)
    await this.#waitForAnimations()
    this.dialogTarget.close()

    this.#closing = false
  }

  #closeOnEsc = event => {
    if (event.key !== 'Escape') return

    event.preventDefault()
    this.close()
  }

  #closeOnBackdrop = ({ target }) => {
    if (this.innerTarget.contains(target)) return

    this.close()
  }

  #waitForAnimations() {
    return Promise.allSettled(this.dialogTarget.getAnimations().map(v => v.finished))
  }

  get #template() {
    return this.templateTarget.content.cloneNode(true)
  }
}
